import React, { useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, useStripe, useElements, CardElement } from '@stripe/react-stripe-js';
import { baseUrl, STRIPE_PUBLIC_KEY } from 'Api';
import stripeCredentials from '../../../../../Api/stripeCredentials.json';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY); // Replace with your Stripe publishable key

const ExpressCheckout = () => {
  const [paymentRequest, setPaymentRequest] = useState(null);
  const [canMakePayment, setCanMakePayment] = useState(false);

  useEffect(() => {
  }, []);

  useEffect(() => {
    const setupPaymentButton = async () => {
      const stripe = await stripePromise;

      const appearance = {
        theme: 'stripe',
        variables: {
          borderRadius: '36px',
        }
      };
      const expressCheckoutOptions = {
        buttonHeight: 50,
        buttonTheme: {
          applePay: 'white-outline'
        },
        buttonType: {
          applePay: 'buy',
          googlePay: 'buy',
        },
        paymentMethods: {
          applePay: 'auto',
          googlePay: 'auto'
        }
      };
      const elements = stripe.elements({
        mode: 'payment',
        amount: 1099,
        currency: 'usd',
        appearance,
      });
      const expressCheckoutElement = elements.create('expressCheckout', expressCheckoutOptions);
      expressCheckoutElement.mount('#express-checkout-element');
    };

    setupPaymentButton(); // Call the async function
  }, []);

  return (
    <div>
      <div id="express-checkout-element">
        {!canMakePayment && <p>Payment options not available.</p>}
      </div>
    </div>
  );
};

export default ExpressCheckout;
